import { render, staticRenderFns } from "./TrademarkObjectionToUsForm.vue?vue&type=template&id=51a658ea&"
import script from "./TrademarkObjectionToUsForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsForm.vue?vue&type=style&index=0&id=51a658ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports